
import {businessListExport, getBasicsetTotalList} from "@/api/http";

let columnList: Array<column> = [
    {
        prop: "number_sets",
        label: "台次",
        width: 55,
    },
    {
        prop: "number_hours",
        label: "工时",
        width: 105,
    },
    {
        prop: "number_parts",
        label: "配件",
        width: 68,
    },
    {
        prop: "number_turnover",
        label: "营业额",
        width: 68,
    },
    {
        prop: "number_cost",
        label: "成本",
        width: 105,
    },
    {
        prop: "number_profit",
        label: "毛利",
        width: 85,
    },
    {
        prop: "number_profit_rate",
        label: "毛利率",
        width: 68,
    },
    {
        prop: "number_parts_cost",
        label: "配件成本",
        width: 68,
    },
    {
        prop: "number_parts_profit",
        label: "配件毛利",
        width: 68,
    },
    // {
    //     prop: "head_office",
    //     label: "平台抽成（元）",
    //     width: 68,
    // },
    
    {
        prop: "number_parts_profit_rate",
        label: "配件毛利率",
        width: 108,
    },
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch
} from "vue";
import {dateformat, getFirstNowLastDay} from "@/api/date" ;
import {Request} from '@/api/request';
import { column } from "@/assets/types/common";
import {useRouter} from "vue-router";
import {ElLoading} from "element-plus";
export default defineComponent({
    name: "businessSummary",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(['营业汇总']);
        
        const headClass = inject("headClass");
        const Router = useRouter();
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<any>),
            total = ref(0),
            selectList = reactive({
                serveTypeList:[]
            }),
            total_price = ref(0),
            head_office_price = ref(0),
            split_office_price = ref(0),
            loading = ref(false),
            totalData = reactive({} as any),
            params = reactive({
                basicset_id:"",
                type:1,
                time: [getFirstNowLastDay()[0],getFirstNowLastDay()[1]],
                start_time: "",
                end_time: "",
            });
        let handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            getSummaries = (param: any): Array<string> => {
                const { columns, data } = param;
                const sums: any = [];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "合计";
                        return;
                    }
                    if (column.property=='number_sets'){
                        sums[index] = totalData.total_number_sets;
                    }
                    if (column.property=='number_cost'){
                        sums[index] = totalData.total_number_cost;
                    }
                    if (column.property=='number_hours'){
                        sums[index] = totalData.total_number_hours;
                    }
                    if (column.property=='number_parts'){
                        sums[index] = totalData.total_number_parts;
                    }
                    if (column.property=='number_parts_cost'){
                        sums[index] = totalData.total_number_parts_cost;
                    }
                    if (column.property=='number_parts_profit'){
                        sums[index] = totalData.total_number_parts_profit;
                    }
                    if (column.property=='number_parts_profit_rate'){
                        sums[index] = totalData.total_number_parts_profit_rate;
                    }
                    if (column.property=='number_profit'){
                        sums[index] = totalData.total_number_profit;
                    }
                    if (column.property=='number_profit_rate'){
                        sums[index] = totalData.total_number_profit_rate;
                    }
                    if (column.property=='number_turnover'){
                        sums[index] = totalData.total_number_turnover;
                    }
                    
                });
                return sums;
            },
            screenChange = (e: string | Array < any > , key: any): void => {
                console.log(params)
                getTableData();
            },
            exportChange = ()=>{
                const loading = ElLoading.service({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                });
                let start_time = params.time?Math.floor(new Date(params.time[0]).getTime()/1000):"";
                let end_time = params.time ?Math.floor((new Date(params.time[1]).getTime()+24*60*60*1000-1)/1000):"";
                let data = {
                    ...params,
                    start_time:start_time,
                    end_time:end_time
                }
                businessListExport(data).then((res:any)=>{
                    loading.close();
                    const url = res.content;
                    window.open(url);
                });
            },
            detailClick = (index:number)=>{
                //let start_time = params.time?Math.floor(new Date(params.time[0]).getTime()/1000):"";
                //let end_time = params.time ?Math.floor((new Date(params.time[1]).getTime()+24*60*60*1000-1)/1000):"";
                let start_time = tableData.value[index].start_date;
                let end_time = tableData.value[index].end_date;
                let serve_type = params.basicset_id
                Router.push({
                    path: '/BusinessReport/businessSummary/businessSummaryDetail',
                    query: {serve_type:serve_type,start_time:start_time,end_time:end_time}
                })
            },
            getTableData = (): void => {
                let start_time = params.time?Math.floor(new Date(params.time[0]).getTime()/1000):"";
                let end_time = params.time ?Math.floor((new Date(params.time[1]).getTime()+24*60*60*1000-1)/1000):"";
                loading.value = true;
                Request.axiosInstance({
                    url: 'adminapi/BusinessSummary/listForPC',
                    data: {
                        page: currentPage.value,
                        pageSize: pageSize.value,
                        ...params,
                        start_time:start_time,
                        end_time:end_time
                    }
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                    totalData = res.content.totals;
                })
                
            }
        onMounted(() => {
            getBasicsetTotalList({basicset_type:2}).then((res:any)=>{
                selectList.serveTypeList = res.content.list;
            });
            getTableData();
        });
        watch(params, (newValue, oldValue) => {
            if (newValue.time == null) {
                params.time = [getFirstNowLastDay()[0],getFirstNowLastDay()[1]];
                getTableData();
            }
        });
        return {
            columnList,
            headClass,
            pageSize,
            currentPage,
            tableData,
            handleSizeChange,
            handleCurrentChange,
            total,
            loading,
            getSummaries,
            total_price,
            head_office_price,
            split_office_price,
            params,
            screenChange,
            selectList,
            detailClick,
            exportChange
        };
    },
});
